module.exports = __webpack_public_path__ + "media/stylesheets/resident/images/ico-flag-d4c0fbec342a66f8b7db0dbf8ccfaf7d.svg";